import { InputFilter }  from '../inputFilter/inputFilter.class'
import { FILTERS }      from '../../constants/filters/filters.constant'

/**
 * @file Defines the {@link InputFilter} class.
 * @author Joe Thompson <joe.thompson@1x2network.com>
 * @version 1.0.27
 */

/** Class for handling functionality of autoInput nodes */
export class AutoInput {

    /**
     * Permitted keypresses allowed
     * Reference to all HTML autoInput nodes
     * @memberof AutoInput
     * @protected
     * @instance
     * @type {Object.<string,number>}
     */
    _allowed

    /**
     * Reference to all HTML autoInput nodes
     * @memberof AutoInput
     * @protected
     * @instance
     * @type {HTMLCollectionOf<Element>}
     */
    _inputs

    /** Initialise autoInput functionality */
    constructor() {

        let inputs = document.getElementsByClassName('auto__input') //Retrieve all auto input nodes

        //Initialise permitted keypresses
        this._allowed = {

            'Delete':       1,
            'Backspace':    1,
            'ArrowUp':      1,
            'ArrowDown':    1,
            'ArrowLeft':    1,
            'ArrowRight':   1,
            '.':            1
    
        }

        //Loop through all auto input nodes
        Array.from(inputs).map(v_ => {

            //Add keydown event listener
            v_.addEventListener('keydown', (e_) => {

                let prevent = false //Whether to prevent input
                
                //If first value entered is not a digit
                if (e_.target.value === '' && !e_.key.match(/[0-9]{1}/)) {
                    prevent = true  //Prevent keypress
                }

                //If inputting zero and key is not permitted
                if (e_.target.value === '0' && !this._allowed[e_.key]) {
                    prevent = true  //Prevent keypress
                }
                
                //If keypress should be prevented
                if (prevent) {
                    e_.preventDefault() //Prevent keypress
                }

            })

        })

        //Apply input filter to auto input nodes to only permit numbers
        Array.from(inputs).map(v_ =>

            new InputFilter(v_).filter(val_ => {
                return FILTERS.currency.test(val_)
            })

        )

    }

}